export class DPRole {
    role_name: string;

    constructor(role_name: string) {
        this.role_name = role_name;
    }
}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-role.ts